import { http } from "msw";

import { withLatency } from "@/mocks/resolvers";
import { errorResponse } from "@/mocks/responses";

type UnhandledHandlerOptions = {
  apiUrl: string;
  storefrontEndpoint: string;
};

const notMockedResolver = withLatency(({ request }) => {
  const { pathname } = new URL(request.url);

  return errorResponse({
    status: 501,
    code: "not_mocked",
    message: `${request.method} ${pathname} has no mock`,
  });
});

export const createUnhandledHandlers = ({
  apiUrl,
  storefrontEndpoint,
}: UnhandledHandlerOptions) => {
  return [
    http.all(`${apiUrl}/*`, notMockedResolver),
    http.all(storefrontEndpoint, notMockedResolver),
  ];
};
